<template lang="pug">
  div.sign-in-bubble-container(@click="handleBubbleClick")
    .sign-in-bubble-coin
      .sign-in-bubble-account(
        v-if="signData && signData.bonusCount"
      ) {{ signData.bonusCount }}
    .sign-in-bubble-title 明日签到
</template>

<script>
import SPM from '../common/spm';

export default {
  name: 'SignInBubble',
  props: {
    // 签到数据
    signData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  mounted() {
    SPM.moduleExpose({
      moduleId: 'bonus_qiandaoyindao',
      contentId: 'bonus_qiandaoyindao',
      businessInfo: {},
    });
  },
  methods: {
    // 气泡点击
    handleBubbleClick() {
      this.$emit('bubbleClick');
      SPM.clickButton({
        buttonName: 'bonus_qiandaoyindao',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.sign-in-bubble-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0.5;
  animation: float 2s ease-in-out infinite;

  @keyframes float {
    0%,
    100% {
      transform: translateY(-0.05rem);
    }

    50% {
      transform: translateY(0);
    }
  }

  .sign-in-bubble-coin {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.51rem;
    height: 0.46rem;
    background-image: url('https://m.hellobike.com/resource/gallery/833/_zy09H_k_Group%201707483331%20(1).png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .sign-in-bubble-account {
    font-family: 'DIN Alternate Bold', sans-serif;
    font-size: 0.13rem;
    line-height: normal;
    color: #996201;
    transform: translate(-0.01rem, 0.01rem);
    text-shadow:
      0 0 0.01rem #fff,
      0 0 0.01rem #fff,
      0 0 0.01rem #fff,
      0 0 0.01rem #fff,
      0 0 0.01rem #fff,
      0 0 0.01rem #fff;
  }

  .sign-in-bubble-title {
    font-size: 0.1rem;
    line-height: 0.14rem;
    font-weight: 600;
    color: #fff;
  }
}
</style>
